import api from './';

interface ProjectSummary {
    id: string;
    organisationId: string;
    name: string;
    key: string;
}

interface FeatureData {
    id?: string;
    key: string;
    name: string;
    description: string;
    projectKey: string;
    project: ProjectSummary;
    variants: Variant[];
    maintainer?: string;
}

export interface Variant {
    description?: string;
    key: string;
    meta?: string;
    name: string;
}

export interface Feature extends FeatureData {
    id: string;
    controls: FeatureControl[];
    projectName: string;
}

export interface FeatureControl {
    archived: boolean;
    available: boolean;
    createdDate: string;
    enabled: boolean;
    environmentKey: string;
    featureId: string;
    id: string;
    key: string;
    offVariantKey: string;
    projectKey: string;
    rules: Rule[];
    rulesDescription?: string;
    staleDays: number;
    statistics: any;
    targetingStatus: string;
    trafficStatus: string;
}

export interface Rule {
    description: string;
    variantSplits: VariantSplit[];
}

export interface VariantSplit {
    variantKey: string;
    split: number;
}

export interface FeatureQuery {
    projectKey?: string;
    environmentKey?: string;
    filter?: string;
    page?: number;
    size?: number;
    sort?: string;
}

export function getRecent(): Promise<Feature[]> {
    return getFilter("recent");
}

export function getBookmarked(): Promise<Feature[]> {
    return getFilter("bookmarked");
}

export function getMaintaining(): Promise<Feature[]> {
    return getFilter("maintaining");
}

export function fetchByProjectKey(projectKey: string): Promise<Feature[]> {
    return get({ projectKey });
}

function getFilter(filter: string): Promise<Feature[]> {
    return api('get', `/api/v1/features?filter=${filter}`);
}

export function get(query: FeatureQuery): Promise<Feature[]> {
    let url = '';
    let {projectKey, environmentKey, filter} = query;
    url = `/api/v1/features`;
    if (projectKey || environmentKey || filter ) {
        url += `?`;
    }
    if (projectKey) {
        url = url + `projectKey=${projectKey}&`
    }
    if (environmentKey) {
        url = url + `environmentKey=${environmentKey}&`
    }
    if (filter) {
        url = url + `query=${filter}`
    }
    return api('get', url);
}

export function update(data: FeatureData): Promise<Feature> {
    return api(data.id ? 'put' : 'post', `/api/v1/projects/${data.projectKey}/features`, {
        data
    });
}

export function link(data: FeatureData): Promise<Feature> {
    return api('put', `/api/v1/features/link`, {
        data
    });
}

export function bookmark(featureId: string, bookmarked: boolean): Promise<void> {
    return api('put', `/api/v1/features/${featureId}/bookmark/${bookmarked}`);
}

export function remove(projectKey: string, featureId: string): Promise<void> {
    return api('delete', `/api/v1/project/${projectKey}/features/${featureId}`);
} 